import { useEffect, useRef, useState } from "react";
import { Controller, useController, useFormContext } from "react-hook-form";
import useFocusErrorForm from "../../../../hooks/useFocusErrorForm";
import useApprovalFieldNavigateTab from "../../../../pages/NewAdsCampaign/hooks/useApprovalFieldNavigateTab";
import {
  ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_MESSAGE_TEMPLATE,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_PLATFORM_DESCRIPTION_MAX_LENGTH,
  ADS_CAMPAIGN_PLATFORM_HEADLINE_MAX_LENGTH,
  ADS_CAMPAIGN_PLATFORM_TITLE_MAX_LENGTH,
  ALERT_ICON_TYPE_SUCCESS,
  IMAGE_FORMATS,
  META,
  MIN_DIMENSIONS_CONTENT,
  VIDEO_FORMATS,
  ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE,
  ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_STATUS_DRAFT,
  ADS_CAMPAIGN_GET_DIRECTIONS_CALL_TO_ACTION_OPTION,
  FROM_MAP_RADIUS_COMPONENT,
  MIN_WIDTH_SCREEN_TO_SHOW_CHAT,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_OFFLINE_TRACKING_ID,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_TRACKING_ID,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WEBSITE,
  ADS_CAMPAIGN_META_PARTNERSHIP_AD_ORDER_SELF_FIRST,
  ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_THRUPLAY,
} from "../../../../utils/constants";
import { useCreditActionCosts } from "../../../../hooks/useCreditActionCosts";
import { BOX_SHADOW_THEME, INPUT_COLOR_BORDER } from "../../../../utils/colors";
import { getIsBlockedActions } from "../../../../actions/getters";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useDispatchApp } from "../../../../lib/redux";
import {
  generalFormatMediaUrl,
  getIsCarouselAdIsAvailable,
  getIsPostAdVisible,
  getIsSpecialAdWithOnlyTitles,
  getIsSpecialAdWithoutCallToAction,
  getShowDestinationTypeAd,
  getShowSiteLinksAdMeta,
} from "../../../../services/adsCampaigns";
import {
  generateAdsCampaignDescription,
  startDeleteAdMediaID,
} from "../../../../actions/adsCampaigns";
import { getUniqueID } from "../../../../utils/numbers";
import {
  buildCreativeOptimizationPrompt,
  getCreativeOptimizationEntryForSlot,
} from "../../../../utils/creativeOptimizationContext";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  useMediaQuery,
} from "@mui/material";
import { useTranslationApp } from "../../../../lib/i18next";
import { getReactHookFormNestedError } from "../../../../utils/errors";
import {
  AD_SCHEDULE_PLACEHOLDER,
  ADS_CAMPAIGN_PREVIEW,
  ADS_CONFIGURATION_DESTINATION_TITLE,
  ADS_CAMPAIGN_META_AD_SETUP,
  ADS_CAMPAIGN_META_AD_SETUP_CREATE_AD,
  ADS_CAMPAIGN_META_AD_SETUP_USE_POST,
  ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD,
  ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD_HINT,
  ADVANTAGE_CATALOG_PLACEHOLDER,
  CALL_TO_ACTION_PLACEHOLDER,
  CARD,
  CAROUSEL,
  CHOOSE_AN_ADDRESS_PLACEHOLDER,
  CONTENT,
  COPY_VALUE_IN_OTHER_ADS,
  COPY_VALUES_IN_OTHER_ADS,
  COPY_VALUES_IN_OTHER_ADGROUPS,
  CREATIVE_SOURCE_PLACEHOLDER,
  CREATIVE_TYPE_PLACEHOLDER,
  DESCRIPTION_PLACEHOLDER,
  DESCRIPTIONS,
  DESTINATION_FALLBACK_CONFIGURATION_TITLE,
  DESTINATION_TYPE_AD_PLACEHOLDER,
  DESTINATION_URL_PLACEHOLDER,
  FIELD_MAX_LENGTH,
  FIELD_MIN_CARDS_AD_CAROUSEL,
  FIELD_REQUIRED,
  FIELD_TEXT_REPEATED,
  FIELD_URL_VALID,
  HEADLINE_PLACEHOLDER,
  HEADLINES,
  INDIVIDUAL,
  INSTANT_FORM_PLACEHOLDER,
  MANUAL_UPLOAD_PLACEHOLDER,
  READY,
  SITE_LINKS_PLACEHOLDER,
  TITLE_PLACEHOLDER,
  TITLES_META,
  TRACKING_EVENTS,
  TRACKING_OFFLINE_EVENTS_PLACEHOLDER,
  TRACKING_WEBSITE_EVENTS,
  UTM_PARAMETERS_PLACEHOLDER,
  WELCOME_MESSAGE_TEMPLATE_PLACEHOLDER,
  BUTTON_CHANGE_SLIDE,
} from "../../../../i18n/keysTranslations";
import { REGEX_URL } from "../../../../utils/regex";
import DestinationFallbackConfiguration from "../../../Common/DestinationFallbackConfiguration";
import ContentField from "../../../Form/ContentField";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import TextField from "../../../Form/TextField";
import { waitDelay } from "../../../../utils/date";
import Select from "../../../Form/Select";
import EditPlacementsMeta from "./EditPlacementsMeta";
import EditAdvantageEnhances from "./EditAdvantageEnhances";
import MessageTemplateContainer from "../../../Meta/MessageTemplateContainer";
import InstantFormContainer from "../../../Meta/InstantFormContainer";
import ClickableText from "../../../Texts/ClickableText";
import InstantFormRecommendedQuestionsTrigger from "./InstantFormRecommended/InstantFormRecommendedQuestionsTrigger";
import { SimpleAlert } from "../../../Alerts/Alerts";
import SelectDestinationTypeAdMeta from "../../../Meta/SelectDestinationTypeAdMeta";
import SelectCallToActionMeta from "./SelectCallToActionMeta";
import AdMetaSiteLinksContainer from "./AdMetaSiteLinksContainer";
import AdCatalogMetaForm from "./AdCatalogMetaForm";
import AdAppPromotionMetaForm from "./AdAppPromotionMetaForm";
import ChipOptional from "../../../Chip/ChipOptional";
import {
  getIsMessageTemplateRequired,
  getIsOnPostDestinationMeta,
  getShowAdScheduleMeta,
} from "../../../../services/meta";
import SelectTrackingIDField from "../../../Form/SelectTrackingIDField";
import FieldOpenMapRadius from "../../../Maps/FieldOpenMapRadius";
import AdScheduleContainerMeta from "./AdScheduleContainerMeta";
import AdPreviewMeta from "./AdPreviewMeta";
import CardContainer from "../../../Card/CardContainer";
import CardContainerWithCopy from "../../../Card/CardContainerWithCopy";
import MetaPartnershipAdConfig from "./MetaPartnershipAdConfig";
import TextFieldWithActions from "../../../Form/TextFieldWithActions";
import _ from "lodash";
import AdAdDynamicContentMetaForm from "./AdAdDynamicContentMetaForm";
import UtmParametersContainer from "../../../Common/Utms/UtmParametersContainer";

const platform = META;
const grid = {
  xs: 12,
  lg: 6,
};

const maxTitlesPlatform = 5;
const maxHeadlinesPlatform = 5;

const AdMetaForm = () => {
  const refPreview = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const {
    watch,
    getValues,
    control,
    formState,
    sectionSelected,
    isGeneralDisabledFields,
    setValue,
    trigger,
    isChatVisible,
  } = useFormContext();
  useFocusErrorForm(formState);

  const breakColumnFormAndPreview = useMediaQuery(() => "(max-width: 1080px)");
  const isLargeScreen = useMediaQuery(
    () => `(min-width: ${MIN_WIDTH_SCREEN_TO_SHOW_CHAT}px)`
  );
  const showSlideChat = isChatVisible && isLargeScreen;

  const errors = formState.errors;
  const adsGroups = watch("adsGroups") || [];

  const adGroupID = sectionSelected.adGroupID;
  const indexAdGroup = adsGroups.findIndex((item) => item.id === adGroupID);
  const adGroup = adsGroups[indexAdGroup];
  const BASIC_PATH_AD_GROUP = `adsGroups.[${indexAdGroup}]`;
  const adID = sectionSelected.adID;
  const indexAd = adGroup?.ads?.findIndex((item) => item.id === adID);
  const BASIC_PATH = `adsGroups.[${indexAdGroup}].ads.[${indexAd}]`;
  const isIncompatibleAd = getValues(`${BASIC_PATH}.isIncompatible`) || false;
  const isCarousel = watch(`${BASIC_PATH}.isCarousel`);
  const isDynamicCreative =
    watch(`${BASIC_PATH_AD_GROUP}.isDynamicCreative`) || false;
  const platformData = watch(`platformsData.${platform}`);
  const destinationTypeAdGroup = watch(
    `${BASIC_PATH_AD_GROUP}.destinationType`
  );
  const optimizationGoalAdGroup = watch(
    `${BASIC_PATH_AD_GROUP}.optimizationGoal`
  );
  const catalogIDAdGroup = watch(`${BASIC_PATH_AD_GROUP}.catalogID`);
  const destinationTypeAd = watch(`${BASIC_PATH}.destinationType`);
  const creativeSource = watch(`${BASIC_PATH}.creativeSource`);
  const callToAction = watch(`${BASIC_PATH}.callToAction`);
  const objective = platformData?.objective;

  const mediaData = watch(`${BASIC_PATH}.mediaData`);

  const isDisabledFields =
    isGeneralDisabledFields ||
    platformData?.isIncompatible ||
    adGroup?.isIncompatible ||
    isIncompatibleAd;

  const dispatch = useDispatchApp();
  const { t } = useTranslationApp();
  const { ADS_CAMPAIGN_GENERATE_TEXT_ACTION } = useCreditActionCosts();

  const isSpecialAdWithOnlyTitles = getIsSpecialAdWithOnlyTitles({
    platform,
    destinationType: destinationTypeAdGroup,
    objective,
  });
  const isSpecialAdWithoutCallToAction = getIsSpecialAdWithoutCallToAction({
    platform,
    destinationTypeAdGroup,
    destinationTypeAd,
    objective,
    mediaData,
    callToAction,
  });
  const isPostAd = watch(`${BASIC_PATH}.isPostAd`);
  const showIsPostAd = getIsPostAdVisible({
    objective,
    destinationType: destinationTypeAdGroup,
  });
  const isCarouselAdsAvailable = getIsCarouselAdIsAvailable({
    platform,
    destinationType: destinationTypeAdGroup,
    isPostAd,
    optimizationGoal: optimizationGoalAdGroup,
  });

  const destinationType = destinationTypeAd || "";

  const isDestinationTypeWebsite =
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WEBSITE.includes(
      destinationTypeAdGroup
    );

  const isDestinationTypePostEngagement =
    destinationTypeAdGroup ===
    ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION;

  const showDestinationTypeAd = getShowDestinationTypeAd({
    objective,
    destinationTypeAdGroup,
  });

  const isDestinationTypeAdWebsite =
    (showDestinationTypeAd &&
      destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION) ||
    !showDestinationTypeAd;

  const isDestinationWebsite =
    isDestinationTypeWebsite && isDestinationTypeAdWebsite;

  const showDestinationUrl =
    isDestinationWebsite ||
    (isDestinationTypePostEngagement &&
      callToAction !== ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE);

  const onGenerateText = async ({ type, index }) => {
    const isBlocked = await dispatch(
      getIsBlockedActions({
        action: ADS_CAMPAIGN_GENERATE_TEXT_ACTION,
        showUsageConfirmationAlert: true,
      })
    );
    if (isBlocked) {
      return;
    }

    const currentTexts = getValues(`${BASIC_PATH}.${type}`) || [];
    const currentText = currentTexts[index]?.value || "";
    const allTexts = currentTexts.map((item) => item.value || "");
    const textsWithCurrentFirst = [
      currentText,
      ...allTexts.filter((_, i) => i !== index),
    ];

    const destinationUrls = getValues(`${BASIC_PATH}.destinationUrls`);
    const destinationUrl =
      destinationUrls?.[index]?.value || destinationUrls?.[0]?.value || "";

    const response = await dispatch(
      generateAdsCampaignDescription({
        objective,
        platform,
        campaignContext: getValues("context") || "",
        language: getValues(`language`),
        destinationUrl,
        type,
        currentTexts: textsWithCurrentFirst,
      })
    );

    if (response) {
      setValue(`${BASIC_PATH}.${type}.[${index}].value`, response);
      trigger(`${BASIC_PATH}.${type}.[${index}].value`);
      onGeneratePreview();
    }
  };

  const onAddText = async ({ type }) => {
    const currentTexts = getValues(`${BASIC_PATH}.${type}`) || [];
    setValue(`${BASIC_PATH}.${type}`, [
      ...currentTexts,
      {
        value: "",
        id: getUniqueID(),
      },
    ]);
    onGeneratePreview();
  };

  const onRemoveText = async ({ type, index }) => {
    const currentTexts = getValues(`${BASIC_PATH}.${type}`);
    setValue(
      `${BASIC_PATH}.${type}`,
      currentTexts.filter((_, i) => i !== index)
    );
    trigger(`${BASIC_PATH}.${type}`);
    onGeneratePreview();
  };

  const onChangeIsCarousel = async (value) => {
    const ads = getValues(`adsGroups.[${indexAdGroup}].ads`);
    const id = getValues(`${BASIC_PATH}.id`);
    setValue(
      `${BASIC_PATH}.destinationType`,
      ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
    );
    if (value) {
      let mediaData = [];
      let mediaUrls = [];
      let mediaIDs = [];
      let newDestinationUrls = [];

      const destinationUrls = getValues(`${BASIC_PATH}.destinationUrls`);
      const destinationUrl = destinationUrls?.[0]?.value || "";

      ads.forEach((ad) => {
        ad.mediaUrls.forEach((mediaUrl, index) => {
          mediaUrls.push(mediaUrl);
          mediaData.push(ad?.mediaData?.[index] || { from: "upload" });
          mediaIDs.push(ad?.mediaIDs?.[index] || "");
          newDestinationUrls.push({ value: destinationUrl, id: getUniqueID() });
        });
      });

      setValue(`${BASIC_PATH}.mediaUrls`, mediaUrls);
      setValue(`${BASIC_PATH}.mediaData`, mediaData);
      setValue(`${BASIC_PATH}.mediaIDs`, mediaIDs);
      setValue(`${BASIC_PATH}.destinationUrls`, newDestinationUrls);
    } else {
      const ad = ads.find((ad) => ad.id === id);
      setValue(`${BASIC_PATH}.mediaUrls`, [ad?.mediaUrls?.[0] || ""]);
      setValue(`${BASIC_PATH}.mediaData`, [
        ad?.mediaData?.[0] || { from: "upload" },
      ]);
      setValue(`${BASIC_PATH}.mediaIDs`, [ad?.mediaIDs?.[0] || ""]);
      setValue(`${BASIC_PATH}.destinationUrls`, [
        ad?.destinationUrls?.[0] || "",
      ]);
      setValue(
        `${BASIC_PATH}.titles`,
        ad?.titles.slice(0, 3) || [{ value: "", id: getUniqueID() }]
      );
      setValue(
        `${BASIC_PATH}.headlines`,
        ad?.headlines.slice(0, 3) || [{ value: "", id: getUniqueID() }]
      );
      setValue(
        `${BASIC_PATH}.descriptions`,
        ad?.descriptions.slice(0, 3) || [{ value: "", id: getUniqueID() }]
      );
    }
    setValue(`${BASIC_PATH}.isCarousel`, value);
    return true;
  };

  const onChangeAdSetupMode = (value) => {
    const mode = value === true ? "post" : value === false ? "create" : value;
    setValue(`${BASIC_PATH}.isCarousel`, false);
    setValue(`${BASIC_PATH}.isInstantExperience`, false);
    setValue(`${BASIC_PATH}.mediaUrls`, []);
    setValue(`${BASIC_PATH}.mediaData`, []);
    setValue(`${BASIC_PATH}.mediaIDs`, []);

    if (mode === "post") {
      setValue(`${BASIC_PATH}.isPostAd`, true);
      setValue(`${BASIC_PATH}.reuseExistingCreative`, false);
      setValue(`${BASIC_PATH}.creativeID`, "");
      setValue(`${BASIC_PATH}.adSetupMode`, "post");
      setValue(`${BASIC_PATH}.isPartnershipAd`, false);
      setValue(
        `${BASIC_PATH}.partnershipOrderType`,
        ADS_CAMPAIGN_META_PARTNERSHIP_AD_ORDER_SELF_FIRST
      );
      setValue(`${BASIC_PATH}.sponsorPageID`, "");
      setValue(`${BASIC_PATH}.sponsorInstagramID`, "");
    } else if (mode === "reuse") {
      setValue(`${BASIC_PATH}.isPostAd`, false);
      setValue(`${BASIC_PATH}.reuseExistingCreative`, true);
      setValue(`${BASIC_PATH}.adSetupMode`, "reuse");
      setValue(`${BASIC_PATH}.creativeID`, "");
    } else {
      setValue(`${BASIC_PATH}.isPostAd`, false);
      setValue(`${BASIC_PATH}.reuseExistingCreative`, false);
      setValue(`${BASIC_PATH}.adSetupMode`, "create");
      setValue(`${BASIC_PATH}.creativeID`, "");
    }
    onGeneratePreview();
  };

  const onChangeIsPostAd = (value) => {
    onChangeAdSetupMode(value ? "post" : "create");
  };

  const onChangeCreativeSource = (value) => {
    setValue(`${BASIC_PATH}.isCarousel`, false);
    setValue(`${BASIC_PATH}.isInstantExperience`, false);

    setValue(`${BASIC_PATH}.mediaUrls`, [""]);
    setValue(`${BASIC_PATH}.mediaData`, [{ from: "upload" }]);

    if (ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.ADVANTAGE_CATALOG === value) {
      setValue(
        `${BASIC_PATH}.titles`,
        getValues(`${BASIC_PATH}.titles`).slice(0, 1)
      );
      setValue(
        `${BASIC_PATH}.descriptions`,
        getValues(`${BASIC_PATH}.descriptions`).slice(0, 1)
      );
      setValue(
        `${BASIC_PATH}.headlines`,
        getValues(`${BASIC_PATH}.headlines`).slice(0, 1)
      );
    }

    if (ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.MANUAL === value) {
      setValue(
        `${BASIC_PATH}.titles`,
        getValues(`${BASIC_PATH}.titles`).slice(0, 3)
      );
      setValue(
        `${BASIC_PATH}.descriptions`,
        getValues(`${BASIC_PATH}.descriptions`).slice(0, 3)
      );
      setValue(
        `${BASIC_PATH}.headlines`,
        getValues(`${BASIC_PATH}.headlines`).slice(0, 3)
      );
    }

    onGeneratePreview();
    setValue(`${BASIC_PATH}.creativeSource`, value);
  };

  const onCopyValuesInOtherAds = ({ type }) => {
    const value = getValues(`${BASIC_PATH}.${type}`);
    const adsOnAdgroup = getValues(`${BASIC_PATH_AD_GROUP}.ads`) || [];

    adsOnAdgroup.forEach((ad, currentIndexAd) => {
      if (ad.id === adID) return;

      setValue(`${BASIC_PATH_AD_GROUP}.ads.[${currentIndexAd}].${type}`, value);
    });

    SimpleAlert({
      title: t(READY),
      icon: ALERT_ICON_TYPE_SUCCESS,
    });
  };

  const onCopyValuesInOtherAdGroups = ({ type }) => {
    const value = getValues(`${BASIC_PATH}.${type}`);
    const adsGroups = getValues("adsGroups") || [];

    adsGroups.forEach((adGroup, currentIndexAdGroup) => {
      if (adGroup.platform !== platform) return;
      if (currentIndexAdGroup === indexAdGroup) return;

      const ads = adGroup?.ads || [];
      ads.forEach((ad, currentIndexAd) => {
        setValue(
          `adsGroups.[${currentIndexAdGroup}].ads.[${currentIndexAd}].${type}`,
          value
        );
      });
    });

    SimpleAlert({
      title: t(READY),
      icon: ALERT_ICON_TYPE_SUCCESS,
    });
  };

  const onGeneratePreview = (from = "") => {
    if (refPreview?.current) {
      refPreview?.current?.generatePreview(from);
    }
  };

  const isCatalogAdGroup =
    destinationTypeAdGroup ===
    ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION;

  const showCreativeSource =
    !platformData?.isCatalogCampaign &&
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION &&
    !isPostAd &&
    !watch(`${BASIC_PATH}.reuseExistingCreative`);

  const isAppAdgroupWithCatalog =
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE.includes(
      destinationTypeAdGroup
    ) && catalogIDAdGroup;

  //To reset values component when change selectedLevel
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await waitDelay(1);
      setIsLoading(false);
    })();
  }, [sectionSelected]);

  useEffect(() => {
    if (showIsPostAd) {
      const currentIsPostAd = getValues(`${BASIC_PATH}.isPostAd`);
      if (currentIsPostAd === undefined || currentIsPostAd === null) {
        setValue(`${BASIC_PATH}.isPostAd`, false);
      }
      if (getValues(`${BASIC_PATH}.reuseExistingCreative`) == null) {
        setValue(`${BASIC_PATH}.reuseExistingCreative`, false);
      }
      if (!getValues(`${BASIC_PATH}.adSetupMode`)) {
        const reuse = getValues(`${BASIC_PATH}.reuseExistingCreative`);
        const post = getValues(`${BASIC_PATH}.isPostAd`);
        setValue(
          `${BASIC_PATH}.adSetupMode`,
          reuse ? "reuse" : post ? "post" : "create"
        );
      }
    } else {
      setValue(`${BASIC_PATH}.isPostAd`, false);
      if (getValues(`${BASIC_PATH}.adSetupMode`) === "post") {
        setValue(`${BASIC_PATH}.adSetupMode`, "create");
      }
    }

    if (isCarousel === null || isCarousel === undefined) {
      setValue(`${BASIC_PATH}.isCarousel`, false);
    }

    if (!showCreativeSource) return;
    const ad = getValues(BASIC_PATH);
    if (ad.creativeSource) return;

    if (ad.isInstantExperience) {
      setValue(
        `${BASIC_PATH}.creativeSource`,
        ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.ADVANTAGE_CATALOG
      );
      return;
    }

    if (ad.productSetID) {
      setValue(
        `${BASIC_PATH}.creativeSource`,
        ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.ADVANTAGE_CATALOG
      );
    } else {
      setValue(
        `${BASIC_PATH}.creativeSource`,
        ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.MANUAL
      );
    }

    //eslint-disable-next-line
  }, []);

  if (isLoading) return null;

  if (
    isCatalogAdGroup ||
    isAppAdgroupWithCatalog ||
    creativeSource === ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.ADVANTAGE_CATALOG
  ) {
    return <AdCatalogMetaForm />;
  }

  if (
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE.includes(
      destinationTypeAdGroup
    ) &&
    (creativeSource === ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.MANUAL ||
      !creativeSource)
  ) {
    return <AdAppPromotionMetaForm />;
  }

  if (isDynamicCreative) {
    return (
      <AdAdDynamicContentMetaForm
        platform={platform}
        platformData={platformData}
        BASIC_PATH_AD_GROUP={BASIC_PATH_AD_GROUP}
        BASIC_PATH={BASIC_PATH}
        onAddText={onAddText}
        onRemoveText={onRemoveText}
        onGenerateText={onGenerateText}
        isSpecialAdWithOnlyTitles={isSpecialAdWithOnlyTitles}
        isSpecialAdWithoutCallToAction={isSpecialAdWithoutCallToAction}
        isGeneralDisabledFields={isDisabledFields}
        errors={errors}
        control={control}
        refPreview={refPreview}
        breakColumnFormAndPreview={breakColumnFormAndPreview}
        objective={objective}
        onGeneratePreview={onGeneratePreview}
        onCopyValuesInOtherAds={onCopyValuesInOtherAds}
        showCreativeSource={showCreativeSource}
        onChangeCreativeSource={onChangeCreativeSource}
        showSlideChat={showSlideChat}
      />
    );
  }

  return (
    <>
      {isCarousel && (
        <AdsAdCarouselForm
          platform={platform}
          BASIC_PATH_AD_GROUP={BASIC_PATH_AD_GROUP}
          BASIC_PATH={BASIC_PATH}
          gridItems={grid}
          onAddText={onAddText}
          onRemoveText={onRemoveText}
          onGenerateText={onGenerateText}
          isSpecialAdWithOnlyTitles={isSpecialAdWithOnlyTitles}
          isSpecialAdWithoutCallToAction={isSpecialAdWithoutCallToAction}
          isGeneralDisabledFields={isDisabledFields}
          errors={errors}
          control={control}
          refPreview={refPreview}
          breakColumnFormAndPreview={breakColumnFormAndPreview}
          platformData={platformData}
          objective={objective}
          onGeneratePreview={onGeneratePreview}
          isCarousel={isCarousel}
          isCarouselAdsAvailable={isCarouselAdsAvailable}
          onChangeIsCarousel={onChangeIsCarousel}
          onCopyValuesInOtherAds={onCopyValuesInOtherAds}
          showCreativeSource={showCreativeSource}
          onChangeCreativeSource={onChangeCreativeSource}
          indexAdGroup={indexAdGroup}
          indexAd={indexAd}
          showSlideChat={showSlideChat}
          showDestinationUrl={showDestinationUrl}
          showIsPostAd={showIsPostAd}
          onChangeAdSetupMode={onChangeAdSetupMode}
        />
      )}
      {!isCarousel && (
        <AdsAdNormalForm
          platform={platform}
          platformData={platformData}
          BASIC_PATH_AD_GROUP={BASIC_PATH_AD_GROUP}
          BASIC_PATH={BASIC_PATH}
          gridItems={grid}
          onAddText={onAddText}
          onRemoveText={onRemoveText}
          onGenerateText={onGenerateText}
          isSpecialAdWithOnlyTitles={isSpecialAdWithOnlyTitles}
          isSpecialAdWithoutCallToAction={isSpecialAdWithoutCallToAction}
          isGeneralDisabledFields={isDisabledFields}
          errors={errors}
          control={control}
          refPreview={refPreview}
          breakColumnFormAndPreview={breakColumnFormAndPreview}
          objective={objective}
          isCarousel={isCarousel}
          isCarouselAdsAvailable={isCarouselAdsAvailable}
          onChangeIsCarousel={onChangeIsCarousel}
          onGeneratePreview={onGeneratePreview}
          onCopyValuesInOtherAds={onCopyValuesInOtherAds}
          onCopyValuesInOtherAdGroups={onCopyValuesInOtherAdGroups}
          showCreativeSource={showCreativeSource}
          onChangeCreativeSource={onChangeCreativeSource}
          showIsPostAd={showIsPostAd}
          onChangeIsPostAd={onChangeIsPostAd}
          onChangeAdSetupMode={onChangeAdSetupMode}
          showSlideChat={showSlideChat}
        />
      )}
    </>
  );
};

const AdsAdCarouselForm = ({
  objective,
  platform,
  platformData,
  breakColumnFormAndPreview,
  BASIC_PATH_AD_GROUP,
  BASIC_PATH,
  onAddText,
  onRemoveText,
  onGenerateText,
  isSpecialAdWithoutCallToAction,
  isGeneralDisabledFields: isGeneralDisabledFieldsProp,
  errors,
  control,
  refPreview,
  onGeneratePreview,
  isCarouselAdsAvailable,
  onChangeIsCarousel,
  onCopyValuesInOtherAds,
  showCreativeSource,
  onChangeCreativeSource,
  indexAdGroup,
  indexAd,
  showSlideChat,
  showDestinationUrl,
  showIsPostAd = false,
  onChangeAdSetupMode = () => {},
}) => {
  const {
    watch,
    setValue,
    creativeOptimizations,
    onRemoveCreativeOptimization,
  } = useFormContext();
  const adID = watch(`${BASIC_PATH}.id`);
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const [tabIndex, setTabIndex] = useState(0);

  const reuseExistingCreative = Boolean(
    watch(`${BASIC_PATH}.reuseExistingCreative`)
  );
  // Reuse mode locks creative config like incompatible; Ad Setup stays editable to exit.
  const isGeneralDisabledFields =
    isGeneralDisabledFieldsProp || reuseExistingCreative;

  const optimizationGoalAdGroup = watch(
    `${BASIC_PATH_AD_GROUP}.optimizationGoal`
  );

  const isThruPlayOptimization =
    optimizationGoalAdGroup === ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_THRUPLAY;

  useApprovalFieldNavigateTab({
    formPath: BASIC_PATH,
    onSelectIndex: setTabIndex,
  });

  useEffect(() => {
    const fields = [
      "mediaUrls",
      "destinationUrls",
      "headlines",
      "descriptions",
    ];
    let firstErrorIndex = null;
    for (const field of fields) {
      const isMediaUrl = field === "mediaUrls";
      const fieldErrors =
        errors?.adsGroups?.[indexAdGroup]?.ads?.[indexAd]?.[field];
      if (Array.isArray(fieldErrors)) {
        let idx;
        if (isMediaUrl) {
          idx = fieldErrors.findIndex((item) => item && item);
        } else {
          idx = fieldErrors.findIndex((item) => item && item.value);
        }
        if (idx !== -1 && (firstErrorIndex === null || idx < firstErrorIndex)) {
          firstErrorIndex = idx;
        }
      }
    }

    if (firstErrorIndex !== null && tabIndex !== firstErrorIndex) {
      setTabIndex(firstErrorIndex);
    }
    //eslint-disable-next-line
  }, [errors, indexAdGroup, indexAd]);

  const handleChangeTab = (event, newValue) => {
    setTabIndex(newValue);
  };

  const errorMediaUrl = getReactHookFormNestedError(
    errors,
    `${BASIC_PATH}.mediaUrls`
  );

  const maxLengthTitle = ADS_CAMPAIGN_PLATFORM_TITLE_MAX_LENGTH[platform];
  const maxLengthDescription =
    ADS_CAMPAIGN_PLATFORM_DESCRIPTION_MAX_LENGTH[platform];
  const maxLengthHeadline = ADS_CAMPAIGN_PLATFORM_HEADLINE_MAX_LENGTH[platform];

  const maxTitles = maxTitlesPlatform;

  const isCatalogCampaign = platformData?.isCatalogCampaign || false;

  const destinationType = watch(`${BASIC_PATH_AD_GROUP}.destinationType`);
  const websiteURL = watch("websiteURL");
  const socialNetworkURL = watch("socialNetworkURL");
  const productContext = watch("productContext");
  const targetContext = watch("targetContext");
  const language = watch("language");
  const ageRange = watch(`${BASIC_PATH_AD_GROUP}.ageRange`);
  const genders = watch(`${BASIC_PATH_AD_GROUP}.genders`);
  const mediaUrlsValue = watch(`${BASIC_PATH}.mediaUrls`);
  const mediaUrls = _.isEmpty(mediaUrlsValue) ? [""] : mediaUrlsValue;
  const mediaData = watch(`${BASIC_PATH}.mediaData`) || [{}];
  const callToAction = watch(`${BASIC_PATH}.callToAction`);
  const titles = watch(`${BASIC_PATH}.titles`) || [{ value: "" }];
  const headlines = watch(`${BASIC_PATH}.headlines`) || [{ value: "" }];
  const descriptions = watch(`${BASIC_PATH}.descriptions`) || [{ value: "" }];
  const destinationUrls = watch(`${BASIC_PATH}.destinationUrls`) || [
    { value: "" },
  ];
  const platformsData = watch("platformsData") || {};

  const showMapCallToAction =
    objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION &&
    callToAction === ADS_CAMPAIGN_GET_DIRECTIONS_CALL_TO_ACTION_OPTION;
  const status = watch(`${BASIC_PATH}.status`);
  const isAdCreated = status !== ADS_CAMPAIGN_STATUS_DRAFT;

  const showTrackingID =
    !(
      ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META.includes(objective) &&
      destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION &&
      !isCatalogCampaign
    ) &&
    !ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_TRACKING_ID.filter(
      (i) => i !== ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
    ).includes(destinationType);

  const showTrackingOfflineID =
    !ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_OFFLINE_TRACKING_ID.includes(
      destinationType
    );

  const showDestinationFallbackConfiguration =
    destinationType ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION ||
    destinationType ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION;

  useEffect(() => {
    if (!showDestinationFallbackConfiguration) return;
    onChangeIsCarousel(false);
    //eslint-disable-next-line
  }, []);

  useController({
    name: `${BASIC_PATH}.mediaUrls`,
    control,
    rules: {
      required: {
        value: true,
        message: t(FIELD_REQUIRED),
      },
      validate: (value) => {
        if (value.length < 1) {
          return t(FIELD_MIN_CARDS_AD_CAROUSEL, {
            value: 1,
          });
        }
      },
    },
  });

  const showDeleteCardIcon = mediaUrls?.length > 2;
  const showAddCardIcon = mediaUrls?.length < 10;

  const onDuplicateCard = async (index) => {
    const mediaUrlItem = mediaUrls[index];
    const mediaDataItem = mediaData[index];
    const headlineItem = headlines[index];
    const descriptionItem = descriptions[index];
    const destinationUrlItem = destinationUrls[index];

    setValue(`${BASIC_PATH}.mediaUrls`, [...mediaUrls, mediaUrlItem], {
      shouldValidate: true,
    });
    setValue(`${BASIC_PATH}.mediaData`, [...mediaData, { ...mediaDataItem }]);

    const newHeadline =
      headlineItem && typeof headlineItem === "object"
        ? { id: getUniqueID(), value: headlineItem?.value || "" }
        : { id: getUniqueID(), value: headlineItem || "" };
    setValue(`${BASIC_PATH}.headlines`, [...headlines, newHeadline]);

    const newDescription =
      descriptionItem && typeof descriptionItem === "object"
        ? { id: getUniqueID(), value: descriptionItem?.value || "" }
        : { id: getUniqueID(), value: descriptionItem || "" };
    setValue(`${BASIC_PATH}.descriptions`, [...descriptions, newDescription]);

    const newDestinationUrl =
      destinationUrlItem && typeof destinationUrlItem === "object"
        ? { id: getUniqueID(), value: destinationUrlItem?.value || "" }
        : { id: getUniqueID(), value: destinationUrlItem || "" };
    setValue(`${BASIC_PATH}.destinationUrls`, [
      ...destinationUrls,
      newDestinationUrl,
    ]);

    setTabIndex(mediaUrls.length);
    onGeneratePreview();
  };
  const onRemoveCard = async (index) => {
    setValue(
      `${BASIC_PATH}.mediaUrls`,
      mediaUrls.filter((_, i) => i !== index)
    );
    setValue(
      `${BASIC_PATH}.mediaData`,
      mediaData.filter((_, i) => i !== index)
    );
    setValue(
      `${BASIC_PATH}.headlines`,
      headlines.filter((_, i) => i !== index)
    );
    setValue(
      `${BASIC_PATH}.descriptions`,
      descriptions.filter((_, i) => i !== index)
    );
    setValue(
      `${BASIC_PATH}.destinationUrls`,
      destinationUrls.filter((_, i) => i !== index)
    );
    if (index === tabIndex && index > 0) {
      setTabIndex(index - 1);
    } else if (index < tabIndex) {
      setTabIndex(tabIndex - 1);
    }
    onGeneratePreview();
  };

  useEffect(() => {
    const entAll = getCreativeOptimizationEntryForSlot({
      creativeOptimizations,
      formPath: BASIC_PATH,
      field: "mediaUrls",
    });
    if (entAll?.title) {
      document
        .getElementById(`${BASIC_PATH}.mediaUrls`)
        ?.scrollIntoView({ behavior: "smooth" });
    }
    // eslint-disable-next-line
  }, [creativeOptimizations, BASIC_PATH, mediaUrls.length]);

  const showAdSchedule = getShowAdScheduleMeta({ objective });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: breakColumnFormAndPreview ? "column" : "row",
        gap: 3,
        width: "100%",
        flexWrap: showSlideChat ? "wrap" : "nowrap",
      }}
    >
      {/* Form */}
      <Grid
        container
        spacing={3}
        sx={{
          height: "min-content",
        }}
      >
        {showIsPostAd && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(ADS_CAMPAIGN_META_AD_SETUP)}
                  </Typography>
                </Box>
              }
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Select
                      disabled={isGeneralDisabledFieldsProp || isAdCreated}
                      variant="filled"
                      name={`${BASIC_PATH}.adSetupMode`}
                      doTranslate={true}
                      actionsChange={(value) => {
                        onChangeAdSetupMode(value);
                      }}
                      control={control}
                      options={[
                        {
                          value: "create",
                          label: ADS_CAMPAIGN_META_AD_SETUP_CREATE_AD,
                        },
                        {
                          value: "post",
                          label: ADS_CAMPAIGN_META_AD_SETUP_USE_POST,
                        },
                        {
                          value: "reuse",
                          label: ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD,
                        },
                      ]}
                    />
                    {reuseExistingCreative && (
                      <Typography variant="body2" color="text.secondary">
                        {t(ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD_HINT)}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </CardContainer>
          </Grid>
        )}
        {/* Card Creative Source */}
        {showCreativeSource && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography sx={{ fontWeight: 600 }} variant="h6">
                    {t(CREATIVE_SOURCE_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name={`${BASIC_PATH}.creativeSource`}
                  render={({ field }) => (
                    <FormControl component="fieldset">
                      <RadioGroup
                        value={field.value}
                        onChange={(e) => {
                          onChangeCreativeSource(e.target.value);
                        }}
                        disabled={isGeneralDisabledFields}
                      >
                        <FormControlLabel
                          value={ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.MANUAL}
                          control={<Radio disabled={isGeneralDisabledFields} />}
                          label={<Box>{t(MANUAL_UPLOAD_PLACEHOLDER)}</Box>}
                        />
                        <FormControlLabel
                          value={
                            ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.ADVANTAGE_CATALOG
                          }
                          control={<Radio disabled={isGeneralDisabledFields} />}
                          label={<Box>{t(ADVANTAGE_CATALOG_PLACEHOLDER)}</Box>}
                        />
                      </RadioGroup>
                    </FormControl>
                  )}
                />
              </Grid>
            </CardContainer>
          </Grid>
        )}
        <MetaPartnershipAdConfig
          basicPath={BASIC_PATH}
          basicPathAdGroup={BASIC_PATH_AD_GROUP}
          platformData={platformData}
          control={control}
          errors={errors}
          isGeneralDisabledFields={isGeneralDisabledFields}
          onGeneratePreview={onGeneratePreview}
        />
        {/* Card 1: Creative Type */}
        {isCarouselAdsAvailable && !showDestinationFallbackConfiguration && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(CREATIVE_TYPE_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Select
                      disabled={isGeneralDisabledFields || isAdCreated}
                      variant="filled"
                      name={`${BASIC_PATH}.isCarousel`}
                      doTranslate={true}
                      actionsChange={(value) => {
                        onChangeIsCarousel(value);
                      }}
                      control={control}
                      options={[
                        { value: false, label: INDIVIDUAL },
                        { value: true, label: CAROUSEL },
                      ]}
                    />
                  </Box>
                </Grid>
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {showDestinationFallbackConfiguration && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(DESTINATION_FALLBACK_CONFIGURATION_TITLE)}
                  </Typography>
                </Box>
              }
            >
              <DestinationFallbackConfiguration
                basicPath={BASIC_PATH}
                control={control}
                errors={errors}
                disabled={isGeneralDisabledFields}
                hideTitle={true}
                onCopyValuesInOtherAds={onCopyValuesInOtherAds}
              />
            </CardContainer>
          </Grid>
        )}

        {/* Card 2: Tabs Carrousel Content */}
        <Grid item xs={12}>
          {/* Error of the image URL */}

          {errorMediaUrl && (
            <Grid item xs={12}>
              <Typography
                name={`${BASIC_PATH}.mediaUrls`}
                variant="body1"
                color="error"
                sx={{
                  mt: 2,
                  mb: -1,
                }}
              >
                {errorMediaUrl.message}
              </Typography>
            </Grid>
          )}

          {/* Preview Tabs */}
          <Grid item xs={12}>
            <Tabs
              value={tabIndex}
              onChange={handleChangeTab}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="Media tabs"
              sx={{
                borderBottom: 1,
                borderColor: "divider",
              }}
            >
              {mediaUrls?.map((_, index) => (
                <Tab key={index} label={`${t(CARD)} ${index + 1}`} />
              ))}
            </Tabs>
          </Grid>

          {/* Preview Cards Tabs*/}
          <Grid item xs={12}>
            <Box
              sx={{
                position: "relative",
                minHeight: "400px",
                transition: "all 0.3s ease-in-out",
                display: "flex",
                flexDirection: "column",
                gap: 2,
                "& > *": {
                  position: "relative",
                  opacity: 1,
                  visibility: "visible",
                  transition: "opacity 0.3s ease-in-out",
                },
              }}
            >
              {mediaUrls?.map((media, index) => {
                const description = descriptions[index] || { value: "" };
                const headline = headlines[index] || { value: "" };
                const destinationUrl = destinationUrls[index] || { value: "" };
                const mediaDataItem = mediaData?.[index] || {};
                const creativeEntry = getCreativeOptimizationEntryForSlot({
                  creativeOptimizations,
                  formPath: BASIC_PATH,
                  field: "mediaUrls",
                });

                const tabKey = destinationUrl?.id || `${index}`;

                return (
                  <Box
                    key={tabKey}
                    sx={{
                      display: index === tabIndex ? "block" : "none",
                      width: "100%",
                    }}
                  >
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          background: "fields.background",
                          border: `1px solid ${INPUT_COLOR_BORDER}`,
                          boxShadow: BOX_SHADOW_THEME,
                          p: 2,
                          borderRadius: 2,
                          height: "100%",
                        }}
                      >
                        {!isGeneralDisabledFields && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                          >
                            {showAddCardIcon && (
                              <IconButton
                                type="button"
                                onClick={(e) => {
                                  e?.stopPropagation();
                                  onDuplicateCard(index);
                                }}
                              >
                                <AddIcon />
                              </IconButton>
                            )}
                            {showDeleteCardIcon && (
                              <IconButton
                                onClick={(e) => {
                                  e?.stopPropagation();
                                  onRemoveCard(index);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            )}
                          </Box>
                        )}

                        <Grid container spacing={3} sx={{ pb: 2, px: 2 }}>
                          <Grid item xs={12} md={8}>
                            <Grid container spacing={2}>
                              {showDestinationUrl && (
                                <Grid item xs={12}>
                                  <Typography variant="body1">
                                    {t(DESTINATION_URL_PLACEHOLDER)}
                                  </Typography>
                                  <ClickableText
                                    disabled={isGeneralDisabledFields}
                                    onClick={() =>
                                      onCopyValuesInOtherAds({
                                        type: "destinationUrls",
                                      })
                                    }
                                  >
                                    {t(COPY_VALUE_IN_OTHER_ADS)}
                                  </ClickableText>
                                  <TextFieldWithActions
                                    key={destinationUrl.id}
                                    type="destinationUrl"
                                    label={""}
                                    name={`${BASIC_PATH}.destinationUrls.[${index}].value`}
                                    disabled={isGeneralDisabledFields}
                                    platform={platform}
                                    showAddIcon={false}
                                    showDeleteIcon={false}
                                    maxLength={maxLengthDescription}
                                    onChange={onGeneratePreview}
                                    control={control}
                                    errors={errors}
                                    rules={{
                                      required: {
                                        value: true,
                                        message: t(FIELD_REQUIRED),
                                      },
                                      validate: (value) => {
                                        if (!REGEX_URL.test(encodeURI(value))) {
                                          return t(FIELD_URL_VALID);
                                        }
                                      },
                                    }}
                                  />
                                </Grid>
                              )}
                              <Grid item xs={12} id={`${BASIC_PATH}.headlines`}>
                                <TextFieldWithActions
                                  key={headline.id}
                                  type="headlines"
                                  label={""}
                                  labelTitle={t(HEADLINE_PLACEHOLDER)}
                                  name={`${BASIC_PATH}.headlines.[${index}].value`}
                                  disabled={isGeneralDisabledFields}
                                  platform={platform}
                                  showAddIcon={false}
                                  showDeleteIcon={false}
                                  maxLength={maxLengthHeadline}
                                  onChange={onGeneratePreview}
                                  onAdd={() => onAddText({ type: "headlines" })}
                                  onRemove={() =>
                                    onRemoveText({ type: "headlines", index })
                                  }
                                  onGenerate={async () => {
                                    await onGenerateText({
                                      type: "headlines",
                                      index,
                                    });
                                  }}
                                  control={control}
                                  errors={errors}
                                  rules={{
                                    required: {
                                      value: true,
                                      message: t(FIELD_REQUIRED),
                                    },
                                    validate: (value) => {
                                      if (value.length > maxLengthHeadline) {
                                        return t(FIELD_MAX_LENGTH, {
                                          value: maxLengthHeadline,
                                        });
                                      }

                                      const allHeadlines = headlines
                                        .map((item) =>
                                          (item.value || "")
                                            .trim()
                                            .toLowerCase()
                                        )
                                        .slice(0, mediaUrls.length);
                                      const timesRepeated = allHeadlines.filter(
                                        (text) =>
                                          text === value.trim().toLowerCase()
                                      ).length;
                                      if (timesRepeated > 1) {
                                        return t(FIELD_TEXT_REPEATED);
                                      }
                                      return true;
                                    },
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                id={`${BASIC_PATH}.descriptions`}
                              >
                                <TextFieldWithActions
                                  key={description.id}
                                  type="descriptions"
                                  label={""}
                                  labelTitle={t(DESCRIPTION_PLACEHOLDER)}
                                  name={`${BASIC_PATH}.descriptions.[${index}].value`}
                                  disabled={isGeneralDisabledFields}
                                  platform={platform}
                                  showAddIcon={false}
                                  showDeleteIcon={false}
                                  maxLength={maxLengthDescription}
                                  onChange={onGeneratePreview}
                                  onAdd={() =>
                                    onAddText({ type: "descriptions" })
                                  }
                                  onRemove={() =>
                                    onRemoveText({
                                      type: "descriptions",
                                      index,
                                    })
                                  }
                                  onGenerate={async () => {
                                    await onGenerateText({
                                      type: "descriptions",
                                      index,
                                    });
                                  }}
                                  control={control}
                                  errors={errors}
                                  rules={{
                                    required: {
                                      value: true,
                                      message: t(FIELD_REQUIRED),
                                    },
                                    validate: (value) => {
                                      if (value.length > maxLengthDescription) {
                                        return t(FIELD_MAX_LENGTH, {
                                          value: maxLengthDescription,
                                        });
                                      }

                                      const allDescriptions = descriptions
                                        .map((item) =>
                                          (item.value || "")
                                            .trim()
                                            .toLowerCase()
                                        )
                                        .slice(0, mediaUrls.length);
                                      const timesRepeated =
                                        allDescriptions.filter(
                                          (text) =>
                                            text === value.trim().toLowerCase()
                                        ).length;
                                      if (timesRepeated > 1) {
                                        return t(FIELD_TEXT_REPEATED);
                                      }
                                      return true;
                                    },
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <Grid container spacing={2}>
                              <Grid
                                item
                                xs={12}
                                id={`${BASIC_PATH}.mediaUrls.[${index}]`}
                                data-field={`${BASIC_PATH}.mediaUrls.[${index}]`}
                              >
                                <ContentField
                                  platform={META}
                                  previewMode="carouselCard"
                                  buttonTextChange={BUTTON_CHANGE_SLIDE}
                                  initialValuesAddContent={
                                    creativeEntry
                                      ? {
                                          prompt:
                                            buildCreativeOptimizationPrompt(
                                              creativeEntry
                                            ),
                                        }
                                      : {}
                                  }
                                  propsSelectContentComponent={{
                                    language,
                                    acceptedFormats: isThruPlayOptimization
                                      ? VIDEO_FORMATS
                                      : VIDEO_FORMATS.concat(IMAGE_FORMATS),
                                    showButtonUpload: true,
                                    showGenerateWithAIOption:
                                      destinationType !==
                                      ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
                                    showUploadDeviceOption:
                                      destinationType !==
                                      ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
                                    showGalleryOption:
                                      destinationType !==
                                      ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
                                    propsPostsAdsPlatforms: platformsData,
                                    destinationType,
                                    propsGenerateAI: {
                                      videoData: mediaDataItem?.videoID
                                        ? {
                                            ...mediaDataItem,
                                            id: mediaDataItem?.videoID,
                                          }
                                        : null,
                                      websiteURL,
                                      socialNetworkURL,
                                      language,
                                      integrationID:
                                        platformData?.integrationID,
                                      adAccountID: platformData?.adAccountID,
                                      campaignContext: {
                                        objective,
                                        productContext,
                                        targetContext,
                                        genders,
                                        ageRange,
                                      },
                                    },
                                  }}
                                  minDimensions={MIN_DIMENSIONS_CONTENT}
                                  onCallbackSave={({ from, content }) => {
                                    const matched =
                                      getCreativeOptimizationEntryForSlot({
                                        creativeOptimizations,
                                        formPath: BASIC_PATH,
                                        field: "mediaUrls",
                                      });
                                    const contentFormatted =
                                      generalFormatMediaUrl({
                                        content,
                                        from,
                                      });
                                    dispatch(
                                      startDeleteAdMediaID({
                                        adID,
                                        index,
                                      })
                                    );
                                    setValue(
                                      `${BASIC_PATH}.mediaIDs.[${index}]`,
                                      ""
                                    );
                                    setValue(
                                      `${BASIC_PATH}.mediaUrls.[${index}]`,
                                      contentFormatted.url,
                                      {
                                        shouldValidate: true,
                                      }
                                    );
                                    setValue(
                                      `${BASIC_PATH}.mediaData.[${index}]`,
                                      contentFormatted.mediaData
                                    );
                                    onGeneratePreview("content");
                                    if (matched?.slotKey) {
                                      onRemoveCreativeOptimization(
                                        matched.slotKey
                                      );
                                    }
                                  }}
                                  label={t(CONTENT)}
                                  name={`${BASIC_PATH}.mediaUrls.[${index}]`}
                                  control={control}
                                  errors={errors}
                                  disabled={isGeneralDisabledFields}
                                  rules={{
                                    required: {
                                      value: true,
                                      message: t(FIELD_REQUIRED),
                                    },
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Box>
                );
              })}
            </Box>
          </Grid>
        </Grid>

        {/* Card 3.1: Welcome Message Template */}
        {ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_MESSAGE_TEMPLATE.includes(
          destinationType
        ) && (
          <Grid
            item
            xs={
              ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_MESSAGE_TEMPLATE.includes(
                destinationType
              ) &&
              objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION &&
              destinationType ===
                ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION
                ? 6
                : 12
            }
          >
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(WELCOME_MESSAGE_TEMPLATE_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Box>
                <MessageTemplateContainer
                  name={`${BASIC_PATH}.messageTemplate`}
                  disabled={isGeneralDisabledFields}
                  fullWidth
                  control={control}
                  errors={errors}
                  rules={{
                    required: { value: true, message: t(FIELD_REQUIRED) },
                  }}
                />
                <ClickableText
                  disabled={isGeneralDisabledFields}
                  onClick={() =>
                    onCopyValuesInOtherAds({ type: "messageTemplate" })
                  }
                >
                  {t(COPY_VALUE_IN_OTHER_ADS)}
                </ClickableText>
              </Box>
            </CardContainer>
          </Grid>
        )}

        {/* Card 3.2: Instant Form (Leads) */}
        {objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION &&
          destinationType ===
            ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION && (
            <Grid
              item
              xs={
                ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_MESSAGE_TEMPLATE.includes(
                  destinationType
                ) &&
                objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION &&
                destinationType ===
                  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION
                  ? 6
                  : 12
              }
            >
              <CardContainer
                title={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: 1,
                      width: "100%",
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {t(INSTANT_FORM_PLACEHOLDER)}
                    </Typography>
                    <Box sx={{ display: "block" }}>
                      <InstantFormRecommendedQuestionsTrigger
                        platformData={platformData}
                        isGeneralDisabledFields={isGeneralDisabledFields}
                      />
                    </Box>
                  </Box>
                }
              >
                <Box>
                  <InstantFormContainer
                    name={`${BASIC_PATH}.instantForm`}
                    integrationID={platformData?.integrationID}
                    pageID={platformData?.pageID}
                    disabled={
                      !platformData?.pageID ||
                      !platformData?.integrationID ||
                      isGeneralDisabledFields
                    }
                    fullWidth
                    control={control}
                    errors={errors}
                    rules={{
                      required: { value: true, message: t(FIELD_REQUIRED) },
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mt: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <ClickableText
                      disabled={isGeneralDisabledFields}
                      onClick={() =>
                        onCopyValuesInOtherAds({ type: "instantForm" })
                      }
                    >
                      {t(COPY_VALUE_IN_OTHER_ADS)}
                    </ClickableText>
                  </Box>
                </Box>
              </CardContainer>
            </Grid>
          )}

        {/* Card 4: Call to Action */}
        {!isSpecialAdWithoutCallToAction && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(CALL_TO_ACTION_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <SelectCallToActionMeta
                      disabled={isGeneralDisabledFields}
                      name={`${BASIC_PATH}.callToAction`}
                      fullWidth
                      objective={objective}
                      platform={platform}
                      destinationType={destinationType}
                      doTranslate={true}
                      control={control}
                      errors={errors}
                      rules={{
                        required: { value: true, message: t(FIELD_REQUIRED) },
                      }}
                    />
                    <ClickableText
                      disabled={isGeneralDisabledFields}
                      onClick={() =>
                        onCopyValuesInOtherAds({ type: "callToAction" })
                      }
                    >
                      {t(COPY_VALUES_IN_OTHER_ADS)}
                    </ClickableText>
                  </Box>
                </Grid>
                {showMapCallToAction && (
                  <Grid item xs={12}>
                    <FieldOpenMapRadius
                      name={`${BASIC_PATH}.address`}
                      onCallbackSave={(locations) => {
                        const location = locations.locations?.[0];
                        if (location) {
                          const address = {
                            lat: location.lat,
                            lng: location.lng,
                            name: location.longName || location.name,
                            type: location.type,
                            id: location.id,
                          };

                          setValue(`${BASIC_PATH}.address`, address);
                          onGeneratePreview();
                        }
                      }}
                      disabled={isGeneralDisabledFields}
                      showButtons={false}
                      titleLabel={t(CHOOSE_AN_ADDRESS_PLACEHOLDER)}
                      maxLocations={1}
                      disableRadius={true}
                      disableAISearch={true}
                      from={FROM_MAP_RADIUS_COMPONENT.AD_ADDRESS}
                    />
                  </Grid>
                )}
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {/* Card 5: UTM Parameters (Leads) */}
        <Grid item xs={12}>
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {t(UTM_PARAMETERS_PLACEHOLDER)}
                </Typography>
                <ChipOptional size="small" />
              </Box>
            }
          >
            <Grid item xs={12}>
              <UtmParametersContainer
                name={`${BASIC_PATH}.utmParameters`}
                control={control}
                errors={errors}
                disabled={isGeneralDisabledFields}
                platform={platform}
                onCopyValuesInOtherAds={() =>
                  onCopyValuesInOtherAds({ type: "utmParameters" })
                }
              />
            </Grid>
          </CardContainer>
        </Grid>

        {(showTrackingID || showTrackingOfflineID) && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(TRACKING_EVENTS)}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
              }
            >
              <Grid container spacing={2}>
                {showTrackingID && (
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(TRACKING_WEBSITE_EVENTS)}
                      </Typography>
                      <SelectTrackingIDField
                        name={`${BASIC_PATH}.trackingID`}
                        disabled={isGeneralDisabledFields}
                        label={""}
                        fullWidth
                        variant="filled"
                        platform={platform}
                        integrationID={platformData?.integrationID}
                        adAccountID={platformData?.adAccountID}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "trackingID" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}
                {showTrackingOfflineID && (
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(TRACKING_OFFLINE_EVENTS_PLACEHOLDER)}
                      </Typography>
                      <SelectTrackingIDField
                        name={`${BASIC_PATH}.trackingOfflineID`}
                        disabled={isGeneralDisabledFields}
                        label={""}
                        fullWidth
                        variant="filled"
                        platform={platform}
                        integrationID={platformData?.integrationID}
                        adAccountID={platformData?.adAccountID}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "trackingOfflineID" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {showAdSchedule && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(AD_SCHEDULE_PLACEHOLDER)}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
              }
            >
              <AdScheduleContainerMeta
                BASIC_PATH={`${BASIC_PATH}`}
                control={control}
                disabled={isGeneralDisabledFields}
              />
            </CardContainer>
          </Grid>
        )}

        {/* Card 5: Titles */}
        <Grid
          item
          xs={12}
          lg={showSlideChat ? 12 : 6}
          id={`${BASIC_PATH}.titles`}
        >
          <CardContainerWithCopy
            title={t(TITLES_META)}
            disabled={isGeneralDisabledFields}
            hasCopyValue={true}
            onCopyCallback={() => onCopyValuesInOtherAds({ type: "titles" })}
            id={`${BASIC_PATH}.titles`}
            copyText={COPY_VALUES_IN_OTHER_ADS}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {titles?.map((title, index) => (
                <TextFieldWithActions
                  labelTitle={t(TITLE_PLACEHOLDER) + " " + (index + 1)}
                  key={title.id}
                  type="titles"
                  name={`${BASIC_PATH}.titles.[${index}].value`}
                  disabled={isGeneralDisabledFields}
                  showAddIcon={
                    index === titles.length - 1 && index < maxTitles - 1
                  }
                  showDeleteIcon={titles.length > 1}
                  platform={platform}
                  onChange={onGeneratePreview}
                  onAdd={() => onAddText({ type: "titles" })}
                  onRemove={() => onRemoveText({ type: "titles", index })}
                  maxLength={maxLengthTitle}
                  onGenerate={async () => {
                    await onGenerateText({ type: "titles", index });
                  }}
                  control={control}
                  errors={errors}
                  rules={{
                    required: { value: true, message: t(FIELD_REQUIRED) },
                    validate: (value) => {
                      if (value.length > maxLengthTitle) {
                        return t(FIELD_MAX_LENGTH, {
                          value: maxLengthTitle,
                        });
                      }
                      const allTitles = titles.map((item) =>
                        (item.value || "").trim().toLowerCase()
                      );
                      const timesRepeated = allTitles.filter(
                        (text) => text === value.trim().toLowerCase()
                      ).length;
                      if (timesRepeated > 1) return t(FIELD_TEXT_REPEATED);
                      return true;
                    },
                  }}
                />
              ))}
            </Box>
          </CardContainerWithCopy>
        </Grid>
      </Grid>

      {/* Preview */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 400,
        }}
      >
        <CardContainer
          dynamicHeight={true}
          title={
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {t(ADS_CAMPAIGN_PREVIEW)}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {!isGeneralDisabledFields && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      gap: 1,
                    }}
                  >
                    <EditAdvantageEnhances
                      disabled={isGeneralDisabledFields}
                      adID={adID}
                      adPathForm={BASIC_PATH}
                      onCallbackSelect={(newAdvantageEnhances) => {
                        setValue(
                          `${BASIC_PATH}.advantageEnhances`,
                          newAdvantageEnhances
                        );
                        onGeneratePreview();
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          }
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <AdPreviewMeta
              adID={adID}
              platform={platform}
              ref={refPreview}
              mediaUrls={mediaUrls}
              mediaData={mediaData}
              callToAction={callToAction}
              titles={titles}
              headlines={headlines}
              descriptions={descriptions}
              destinationUrls={destinationUrls}
              basicPath={BASIC_PATH}
              basicPathAdGroup={BASIC_PATH_AD_GROUP}
            />
          </Box>
        </CardContainer>
      </Box>
    </Box>
  );
};

const AdsAdNormalForm = ({
  objective,
  platform,
  platformData,
  breakColumnFormAndPreview,
  BASIC_PATH_AD_GROUP,
  BASIC_PATH,
  onAddText,
  onRemoveText,
  onGenerateText,
  isSpecialAdWithOnlyTitles,
  isSpecialAdWithoutCallToAction,
  isGeneralDisabledFields: isGeneralDisabledFieldsProp,
  errors,
  control,
  refPreview,
  isCarouselAdsAvailable,
  onChangeIsCarousel,
  onGeneratePreview,
  onCopyValuesInOtherAds,
  onCopyValuesInOtherAdGroups,
  showCreativeSource,
  onChangeCreativeSource,
  showSlideChat,
  showIsPostAd = false,
  onChangeAdSetupMode = () => {},
}) => {
  const { watch, setValue } = useFormContext();
  const { t } = useTranslationApp();

  const maxLengthTitle = ADS_CAMPAIGN_PLATFORM_TITLE_MAX_LENGTH[platform];
  const maxLengthDescription =
    ADS_CAMPAIGN_PLATFORM_DESCRIPTION_MAX_LENGTH[platform];
  const maxLengthHeadline = ADS_CAMPAIGN_PLATFORM_HEADLINE_MAX_LENGTH[platform];

  const maxTitles = maxTitlesPlatform;
  const maxHeadlines = maxHeadlinesPlatform;

  const adID = watch(`${BASIC_PATH}.id`);

  const isCatalogCampaign = platformData?.isCatalogCampaign || false;

  const language = watch("language");

  const mediaUrls = watch(`${BASIC_PATH}.mediaUrls`);
  const mediaData = watch(`${BASIC_PATH}.mediaData`);
  const callToAction = watch(`${BASIC_PATH}.callToAction`);
  const titles = watch(`${BASIC_PATH}.titles`) || [{ value: "" }];
  const headlines = watch(`${BASIC_PATH}.headlines`) || [{ value: "" }];
  const descriptions = watch(`${BASIC_PATH}.descriptions`) || [{ value: "" }];
  const destinationType = watch(`${BASIC_PATH}.destinationType`) || "";
  const destinationTypeAdGroup = watch(
    `${BASIC_PATH_AD_GROUP}.destinationType`
  );
  const optimizationGoalAdGroup = watch(
    `${BASIC_PATH_AD_GROUP}.optimizationGoal`
  );
  const status = watch(`${BASIC_PATH}.status`);
  const isAdCreated = status !== ADS_CAMPAIGN_STATUS_DRAFT;
  const isPostAd = watch(`${BASIC_PATH}.isPostAd`);
  const reuseExistingCreative = Boolean(
    watch(`${BASIC_PATH}.reuseExistingCreative`)
  );
  // Reuse mode locks creative config like incompatible; Ad Setup stays editable to exit.
  const isGeneralDisabledFields =
    isGeneralDisabledFieldsProp || reuseExistingCreative;
  const isThruPlayOptimization =
    optimizationGoalAdGroup === ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_THRUPLAY;
  const isDestinationTypeWebsite =
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WEBSITE.includes(
      destinationTypeAdGroup
    );

  const showDestinationTypeAd = getShowDestinationTypeAd({
    objective,
    destinationTypeAdGroup,
  });

  const showSiteLinksAdMeta = getShowSiteLinksAdMeta({
    objective,
    destinationType: destinationTypeAdGroup,
    destinationTypeAd: destinationType,
  });

  const showTrackingID =
    !(
      ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META.includes(objective) &&
      destinationTypeAdGroup ===
        ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION &&
      !isCatalogCampaign
    ) &&
    !ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_TRACKING_ID.filter(
      (i) => i !== ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
    ).includes(destinationTypeAdGroup);

  const showTrackingOfflineID =
    !ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_OFFLINE_TRACKING_ID.includes(
      destinationTypeAdGroup
    );

  const showDestinationFallbackConfiguration =
    destinationTypeAdGroup ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION ||
    destinationTypeAdGroup ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION;

  const isDestinationTypeAdWebsite =
    (showDestinationTypeAd &&
      destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION) ||
    !showDestinationTypeAd;

  const isDestinationWebsite =
    isDestinationTypeWebsite && isDestinationTypeAdWebsite;

  const isOnPostDestination = getIsOnPostDestinationMeta({
    destinationType: destinationTypeAdGroup,
    isPostAd,
  });

  const showDestinationUrl =
    isDestinationWebsite ||
    (isOnPostDestination &&
      callToAction !== ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE);

  //LOGIC RENDER CARD: Destination Type configuration
  const showUtmParameters = true;
  const shouldShowDestinationConfigCard =
    showUtmParameters || // UTM parameters must always be shown
    showDestinationTypeAd ||
    showSiteLinksAdMeta ||
    showDestinationUrl;

  const destinationSections = [
    showDestinationTypeAd,
    showDestinationUrl,
    showSiteLinksAdMeta,
  ];

  const destinationSectionsCount = destinationSections.filter(Boolean).length;
  const isSingleDestinationSection = destinationSectionsCount + 1 === 1;

  const isMessageTemplateRequired = getIsMessageTemplateRequired({
    objective,
    mediaData,
    callToAction,
    destinationType: destinationTypeAdGroup,
    isPostAd,
  });

  const showMapCallToAction =
    objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION &&
    callToAction === ADS_CAMPAIGN_GET_DIRECTIONS_CALL_TO_ACTION_OPTION;

  const showAdSchedule = getShowAdScheduleMeta({ objective, isPostAd });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: breakColumnFormAndPreview ? "column" : "row",
        gap: 4,
        width: "100%",
        flexWrap: showSlideChat ? "wrap" : "nowrap",
      }}
    >
      {/* FORM */}
      <Grid container spacing={3} sx={{ height: "min-content" }}>
        {/* Card Ad Setup */}
        {showIsPostAd && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(ADS_CAMPAIGN_META_AD_SETUP)}
                  </Typography>
                </Box>
              }
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Select
                      disabled={isGeneralDisabledFieldsProp || isAdCreated}
                      variant="filled"
                      name={`${BASIC_PATH}.adSetupMode`}
                      doTranslate={true}
                      actionsChange={(value) => {
                        onChangeAdSetupMode(value);
                      }}
                      control={control}
                      options={[
                        {
                          value: "create",
                          label: ADS_CAMPAIGN_META_AD_SETUP_CREATE_AD,
                        },
                        {
                          value: "post",
                          label: ADS_CAMPAIGN_META_AD_SETUP_USE_POST,
                        },
                        {
                          value: "reuse",
                          label: ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD,
                        },
                      ]}
                    />
                    {reuseExistingCreative && (
                      <Typography variant="body2" color="text.secondary">
                        {t(ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD_HINT)}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </CardContainer>
          </Grid>
        )}
        {/* Card Creative Source */}
        {showCreativeSource && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography sx={{ fontWeight: 600 }} variant="h6">
                    {t(CREATIVE_SOURCE_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name={`${BASIC_PATH}.creativeSource`}
                  render={({ field }) => (
                    <FormControl component="fieldset">
                      <RadioGroup
                        value={field.value}
                        onChange={(e) => {
                          onChangeCreativeSource(e.target.value);
                        }}
                        disabled={isGeneralDisabledFields}
                      >
                        <FormControlLabel
                          value={ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.MANUAL}
                          control={<Radio disabled={isGeneralDisabledFields} />}
                          label={<Box>{t(MANUAL_UPLOAD_PLACEHOLDER)}</Box>}
                        />
                        <FormControlLabel
                          value={
                            ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.ADVANTAGE_CATALOG
                          }
                          control={<Radio disabled={isGeneralDisabledFields} />}
                          label={<Box>{t(ADVANTAGE_CATALOG_PLACEHOLDER)}</Box>}
                        />
                      </RadioGroup>
                    </FormControl>
                  )}
                />
              </Grid>
            </CardContainer>
          </Grid>
        )}
        <MetaPartnershipAdConfig
          basicPath={BASIC_PATH}
          basicPathAdGroup={BASIC_PATH_AD_GROUP}
          platformData={platformData}
          control={control}
          errors={errors}
          isGeneralDisabledFields={isGeneralDisabledFields}
          onGeneratePreview={onGeneratePreview}
        />
        {/* CARD: Creative Type */}
        {isCarouselAdsAvailable && !showDestinationFallbackConfiguration && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(CREATIVE_TYPE_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Select
                      disabled={isGeneralDisabledFields || isAdCreated}
                      variant="filled"
                      name={`${BASIC_PATH}.isCarousel`}
                      doTranslate={true}
                      actionsChange={(value) => {
                        onChangeIsCarousel(value);
                      }}
                      control={control}
                      options={[
                        { value: false, label: INDIVIDUAL },
                        { value: true, label: CAROUSEL },
                      ]}
                    />
                  </Box>
                </Grid>
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {showDestinationFallbackConfiguration && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(DESTINATION_FALLBACK_CONFIGURATION_TITLE)}
                  </Typography>
                </Box>
              }
            >
              <DestinationFallbackConfiguration
                basicPath={BASIC_PATH}
                control={control}
                errors={errors}
                disabled={isGeneralDisabledFields}
                hideTitle={true}
                onCopyValuesInOtherAds={onCopyValuesInOtherAds}
              />
            </CardContainer>
          </Grid>
        )}

        {/* Card 2: Configuración de Destino */}
        {shouldShowDestinationConfigCard && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(ADS_CONFIGURATION_DESTINATION_TITLE)}
                  </Typography>
                </Box>
              }
            >
              <Grid container spacing={2}>
                {showDestinationTypeAd && (
                  <Grid item xs={isSingleDestinationSection ? 12 : 6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(DESTINATION_TYPE_AD_PLACEHOLDER)}
                      </Typography>
                      <SelectDestinationTypeAdMeta
                        name={`${BASIC_PATH}.destinationType`}
                        objective={objective}
                        variant="filled"
                        fullWidth={true}
                        disabled={isGeneralDisabledFields || isAdCreated}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAdGroups({
                            type: "destinationType",
                          })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADGROUPS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}

                {/* Destination URL Input */}
                {showDestinationUrl && (
                  <Grid item xs={isSingleDestinationSection ? 12 : 6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(DESTINATION_URL_PLACEHOLDER)}
                      </Typography>
                      <TextField
                        name={`${BASIC_PATH}.destinationUrls.[0].value`}
                        variant="filled"
                        fullWidth
                        disabled={isGeneralDisabledFields}
                        actionsChange={() => {
                          onGeneratePreview();
                        }}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "destinationUrls" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}

                {/* UTM Input */}
                {showUtmParameters && (
                  <Grid item xs={isSingleDestinationSection ? 12 : 6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Box
                        sx={{ display: "flex", gap: 1, alignItems: "center" }}
                      >
                        <Typography variant="body1">
                          {t(UTM_PARAMETERS_PLACEHOLDER)}
                        </Typography>
                        <ChipOptional size="small" />
                      </Box>
                      <UtmParametersContainer
                        name={`${BASIC_PATH}.utmParameters`}
                        control={control}
                        errors={errors}
                        disabled={isGeneralDisabledFields}
                        platform={platform}
                        onCopyValuesInOtherAds={() =>
                          onCopyValuesInOtherAds({ type: "utmParameters" })
                        }
                      />
                    </Box>
                  </Grid>
                )}

                {/* Site Links Input */}
                {showSiteLinksAdMeta && (
                  <Grid item xs={isSingleDestinationSection ? 12 : 6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(SITE_LINKS_PLACEHOLDER)}
                      </Typography>
                      <AdMetaSiteLinksContainer
                        name={`${BASIC_PATH}.siteLinks`}
                        variant="filled"
                        language={language}
                        fullWidth={true}
                        disabled={isGeneralDisabledFields}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "siteLinks" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {/* Card 3.1: Message Template */}
        {isMessageTemplateRequired && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(WELCOME_MESSAGE_TEMPLATE_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Box>
                <MessageTemplateContainer
                  name={`${BASIC_PATH}.messageTemplate`}
                  disabled={isGeneralDisabledFields}
                  fullWidth
                  control={control}
                  errors={errors}
                  rules={{
                    required: { value: true, message: t(FIELD_REQUIRED) },
                  }}
                />
                <ClickableText
                  disabled={isGeneralDisabledFields}
                  onClick={() =>
                    onCopyValuesInOtherAds({ type: "messageTemplate" })
                  }
                >
                  {t(COPY_VALUE_IN_OTHER_ADS)}
                </ClickableText>
              </Box>
            </CardContainer>
          </Grid>
        )}

        {/* Card 3.2: Instant Form */}
        {objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION &&
          destinationTypeAdGroup ===
            ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION && (
            <Grid
              item
              xs={
                ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_MESSAGE_TEMPLATE.includes(
                  destinationTypeAdGroup
                ) &&
                objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION &&
                destinationTypeAdGroup ===
                  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION
                  ? 6
                  : 12
              }
            >
              <CardContainer
                title={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: 1,
                      width: "100%",
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {t(INSTANT_FORM_PLACEHOLDER)}
                    </Typography>
                    <Box sx={{ display: "block" }}>
                      <InstantFormRecommendedQuestionsTrigger
                        platformData={platformData}
                        isGeneralDisabledFields={isGeneralDisabledFields}
                      />
                    </Box>
                  </Box>
                }
              >
                <Box>
                  <InstantFormContainer
                    name={`${BASIC_PATH}.instantForm`}
                    integrationID={platformData?.integrationID}
                    pageID={platformData?.pageID}
                    disabled={
                      !platformData?.pageID ||
                      !platformData?.integrationID ||
                      isGeneralDisabledFields
                    }
                    fullWidth
                    control={control}
                    errors={errors}
                    rules={{
                      required: { value: true, message: t(FIELD_REQUIRED) },
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mt: 1,
                      gap: 1,
                      flexWrap: "wrap",
                      "@media (max-width: 600px)": {
                        flexDirection: "column",
                      },
                    }}
                  >
                    <ClickableText
                      disabled={isGeneralDisabledFields}
                      onClick={() =>
                        onCopyValuesInOtherAds({ type: "instantForm" })
                      }
                    >
                      {t(COPY_VALUE_IN_OTHER_ADS)}
                    </ClickableText>
                  </Box>
                </Box>
              </CardContainer>
            </Grid>
          )}

        {/* CARD: Call to Action */}
        {!isSpecialAdWithoutCallToAction && isDestinationTypeAdWebsite && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(CALL_TO_ACTION_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      mb: 2,
                    }}
                  >
                    <SelectCallToActionMeta
                      disabled={isGeneralDisabledFields}
                      name={`${BASIC_PATH}.callToAction`}
                      fullWidth
                      objective={objective}
                      platform={platform}
                      destinationType={destinationTypeAdGroup}
                      mediaData={mediaData}
                      doTranslate={true}
                      control={control}
                      errors={errors}
                      rules={{
                        required: {
                          value: true,
                          message: t(FIELD_REQUIRED),
                        },
                      }}
                    />
                    <ClickableText
                      disabled={isGeneralDisabledFields}
                      onClick={() =>
                        onCopyValuesInOtherAds({ type: "callToAction" })
                      }
                    >
                      {t(COPY_VALUES_IN_OTHER_ADS)}
                    </ClickableText>
                  </Box>
                  {showMapCallToAction && (
                    <Grid item xs={12}>
                      <FieldOpenMapRadius
                        name={`${BASIC_PATH}.address`}
                        onCallbackSave={(locations) => {
                          const location = locations.locations?.[0];
                          if (location) {
                            const address = {
                              lat: location.lat,
                              lng: location.lng,
                              name: location.longName || location.name,
                              type: location.type,
                              id: location.id,
                            };

                            setValue(`${BASIC_PATH}.address`, address);
                            onGeneratePreview();
                          }
                        }}
                        disabled={isGeneralDisabledFields}
                        showButtons={false}
                        from={FROM_MAP_RADIUS_COMPONENT.AD_ADDRESS}
                        titleLabel={CHOOSE_AN_ADDRESS_PLACEHOLDER}
                        maxLocations={1}
                        disableRadius={true}
                        disableAISearch={true}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {showAdSchedule && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(AD_SCHEDULE_PLACEHOLDER)}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
              }
            >
              <AdScheduleContainerMeta
                BASIC_PATH={`${BASIC_PATH}`}
                control={control}
                disabled={isGeneralDisabledFields}
              />
            </CardContainer>
          </Grid>
        )}

        {(showTrackingID || showTrackingOfflineID) && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(TRACKING_EVENTS)}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
              }
            >
              <Grid container spacing={2}>
                {showTrackingID && (
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(TRACKING_WEBSITE_EVENTS)}
                      </Typography>
                      <SelectTrackingIDField
                        name={`${BASIC_PATH}.trackingID`}
                        disabled={isGeneralDisabledFields}
                        label={""}
                        fullWidth
                        variant="filled"
                        platform={platform}
                        integrationID={platformData?.integrationID}
                        adAccountID={platformData?.adAccountID}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "trackingID" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}
                {showTrackingOfflineID && (
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(TRACKING_OFFLINE_EVENTS_PLACEHOLDER)}
                      </Typography>
                      <SelectTrackingIDField
                        name={`${BASIC_PATH}.trackingOfflineID`}
                        disabled={isGeneralDisabledFields}
                        label={""}
                        fullWidth
                        variant="filled"
                        platform={platform}
                        integrationID={platformData?.integrationID}
                        adAccountID={platformData?.adAccountID}
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        disabled={isGeneralDisabledFields}
                        onClick={() =>
                          onCopyValuesInOtherAds({ type: "trackingOfflineID" })
                        }
                      >
                        {t(COPY_VALUES_IN_OTHER_ADS)}
                      </ClickableText>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </CardContainer>
          </Grid>
        )}

        {/* Card 5: Títulos del Anuncio */}
        <Grid
          item
          xs={12}
          lg={showSlideChat ? 12 : 6}
          id={`${BASIC_PATH}.titles`}
        >
          <CardContainerWithCopy
            title={t(TITLES_META)}
            disabled={isGeneralDisabledFields}
            hasCopyValue={true}
            onCopyCallback={() => onCopyValuesInOtherAds({ type: "titles" })}
            id={`${BASIC_PATH}.titles`}
            copyText={COPY_VALUES_IN_OTHER_ADS}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {titles?.map((title, index) => (
                <TextFieldWithActions
                  key={title.id}
                  type="titles"
                  labelTitle={t(TITLE_PLACEHOLDER) + " " + (index + 1)}
                  name={`${BASIC_PATH}.titles.[${index}].value`}
                  disabled={isGeneralDisabledFields}
                  showAddIcon={
                    !reuseExistingCreative &&
                    index === titles.length - 1 &&
                    index < maxTitles - 1
                  }
                  showDeleteIcon={titles.length > 1 && !reuseExistingCreative}
                  platform={platform}
                  onChange={onGeneratePreview}
                  onAdd={() => onAddText({ type: "titles" })}
                  onRemove={() => onRemoveText({ type: "titles", index })}
                  maxLength={maxLengthTitle}
                  onGenerate={async () => {
                    await onGenerateText({ type: "titles", index });
                  }}
                  control={control}
                  errors={errors}
                  rules={{
                    required: { value: true, message: t(FIELD_REQUIRED) },
                    validate: (value) => {
                      if (value.length > maxLengthTitle) {
                        return t(FIELD_MAX_LENGTH, {
                          value: maxLengthTitle,
                        });
                      }
                      const allTitles = titles.map((item) =>
                        (item.value || "").trim().toLowerCase()
                      );
                      const timesRepeated = allTitles.filter(
                        (text) => text === value.trim().toLowerCase()
                      ).length;
                      if (timesRepeated > 1) return t(FIELD_TEXT_REPEATED);
                      return true;
                    },
                  }}
                />
              ))}
            </Box>
          </CardContainerWithCopy>
        </Grid>

        {!isSpecialAdWithOnlyTitles &&
          isDestinationTypeAdWebsite &&
          !isPostAd && (
            <Grid
              item
              xs={12}
              lg={showSlideChat ? 12 : 6}
              id={`${BASIC_PATH}.descriptions`}
            >
              <CardContainerWithCopy
                title={t(DESCRIPTIONS)}
                disabled={isGeneralDisabledFields}
                hasCopyValue={true}
                onCopyCallback={() =>
                  onCopyValuesInOtherAds({ type: "descriptions" })
                }
                id={`${BASIC_PATH}.descriptions`}
                copyText={COPY_VALUES_IN_OTHER_ADS}
              >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {descriptions?.map((description, index) => (
                    <>
                      <TextFieldWithActions
                        key={description.id}
                        type="descriptions"
                        labelTitle={
                          t(DESCRIPTION_PLACEHOLDER) + " " + (index + 1)
                        }
                        name={`${BASIC_PATH}.descriptions.[${index}].value`}
                        disabled={isGeneralDisabledFields}
                        showAddIcon={false}
                        showDeleteIcon={
                          descriptions.length > 1 && !reuseExistingCreative
                        }
                        platform={platform}
                        onChange={onGeneratePreview}
                        onAdd={() => onAddText({ type: "descriptions" })}
                        onRemove={() =>
                          onRemoveText({ type: "descriptions", index })
                        }
                        maxLength={maxLengthDescription}
                        onGenerate={async () => {
                          await onGenerateText({ type: "descriptions", index });
                        }}
                        control={control}
                        errors={errors}
                        rules={{
                          required: { value: true, message: t(FIELD_REQUIRED) },
                          validate: (value) => {
                            if (value.length > maxLengthDescription) {
                              return t(FIELD_MAX_LENGTH, {
                                value: maxLengthDescription,
                              });
                            }
                            const allDescriptions = descriptions.map((item) =>
                              (item.value || "").trim().toLowerCase()
                            );
                            const timesRepeated = allDescriptions.filter(
                              (text) => text === value.trim().toLowerCase()
                            ).length;
                            if (timesRepeated > 1)
                              return t(FIELD_TEXT_REPEATED);
                            return true;
                          },
                        }}
                      />
                    </>
                  ))}
                </Box>
              </CardContainerWithCopy>
            </Grid>
          )}

        {!isSpecialAdWithOnlyTitles &&
          isDestinationTypeAdWebsite &&
          !isPostAd && (
            <Grid
              item
              xs={12}
              lg={showSlideChat ? 12 : 6}
              id={`${BASIC_PATH}.headlines`}
            >
              <CardContainerWithCopy
                title={t(HEADLINES)}
                disabled={isGeneralDisabledFields}
                hasCopyValue={true}
                onCopyCallback={() =>
                  onCopyValuesInOtherAds({ type: "headlines" })
                }
                id={`${BASIC_PATH}.headlines`}
                copyText={COPY_VALUES_IN_OTHER_ADS}
              >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {headlines?.map((headline, index) => (
                    <TextFieldWithActions
                      key={headline.id}
                      type="headlines"
                      labelTitle={t(HEADLINE_PLACEHOLDER) + " " + (index + 1)}
                      name={`${BASIC_PATH}.headlines.[${index}].value`}
                      disabled={isGeneralDisabledFields}
                      showAddIcon={
                        !reuseExistingCreative &&
                        index === headlines.length - 1 &&
                        index < maxHeadlines - 1
                      }
                      showDeleteIcon={
                        headlines.length > 1 && !reuseExistingCreative
                      }
                      platform={platform}
                      onChange={onGeneratePreview}
                      onAdd={() => onAddText({ type: "headlines" })}
                      onRemove={() =>
                        onRemoveText({ type: "headlines", index })
                      }
                      maxLength={maxLengthHeadline}
                      onGenerate={async () => {
                        await onGenerateText({ type: "headlines", index });
                      }}
                      control={control}
                      errors={errors}
                      rules={{
                        required: { value: true, message: t(FIELD_REQUIRED) },
                        validate: (value) => {
                          if (value.length > maxLengthHeadline) {
                            return t(FIELD_MAX_LENGTH, {
                              value: maxLengthHeadline,
                            });
                          }
                          const allHeadlines = headlines.map((item) =>
                            (item.value || "").trim().toLowerCase()
                          );
                          const timesRepeated = allHeadlines.filter(
                            (text) => text === value.trim().toLowerCase()
                          ).length;
                          if (timesRepeated > 1) return t(FIELD_TEXT_REPEATED);
                          return true;
                        },
                      }}
                    />
                  ))}
                </Box>
              </CardContainerWithCopy>
            </Grid>
          )}
      </Grid>

      {/* Preview */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 400,
        }}
      >
        <CardContainer
          dynamicHeight={true}
          title={
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography variant="h6">{t(ADS_CAMPAIGN_PREVIEW)}</Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                {!isGeneralDisabledFields && (
                  <EditAdvantageEnhances
                    disabled={isGeneralDisabledFields}
                    adID={adID}
                    adPathForm={BASIC_PATH}
                    onCallbackSelect={(newAdvantageEnhances) => {
                      setValue(
                        `${BASIC_PATH}.advantageEnhances`,
                        newAdvantageEnhances
                      );
                      onGeneratePreview();
                    }}
                  />
                )}
                {!isOnPostDestination && !isThruPlayOptimization && (
                  <EditPlacementsMeta
                    language={language}
                    disabled={isGeneralDisabledFields}
                    destinationType={destinationTypeAdGroup}
                    adID={adID}
                    adPathForm={BASIC_PATH}
                    adGroupPathForm={BASIC_PATH_AD_GROUP}
                    onCallbackSelect={(customizationPlacements) => {
                      const currentMediaData = watch(`${BASIC_PATH}.mediaData`);
                      if (!currentMediaData?.[0]) {
                        currentMediaData[0] = { from: "upload" };
                      }
                      currentMediaData[0].customizationPlacements =
                        customizationPlacements;
                      setValue(`${BASIC_PATH}.mediaData`, currentMediaData);
                      onGeneratePreview("content");
                    }}
                  />
                )}
              </Box>
            </Box>
          }
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <AdPreviewMeta
              ref={refPreview}
              adID={adID}
              mediaUrls={mediaUrls}
              mediaData={mediaData}
              callToAction={callToAction}
              titles={titles}
              headlines={headlines}
              descriptions={descriptions}
              platform={platform}
              basicPath={BASIC_PATH}
              basicPathAdGroup={BASIC_PATH_AD_GROUP}
            />
          </Box>
        </CardContainer>
      </Box>
    </Box>
  );
};

export default AdMetaForm;
